import { render } from "./Treecontextmenu.vue?vue&type=template&id=4965f631"
import script from "./Treecontextmenu.vue?vue&type=script&lang=js"
export * from "./Treecontextmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__